export default {
  validations: {
    numeric: 'Numbers only',
    passport_numeric: 'Check if passport ID number is correct',
    password:'The password must consist of Latin letters (A-z), Arabic numerals (0-9) and special characters @%!?',
    passport_id_numeric: 'Check if ID number is correct. Only digits, letters of the Latiin alphabet, spaces, dot and dashes can be used',
    pw_confirm: 'Passwords do not match',
    required: 'Field is required',
    min: 'Minimum amount of symbols: {length}',
    max: 'Maximum amount of symbols: {length}',
    length: 'An amount of symbols must be even {length}',
    email: 'Check that your email has been entered correctly',
    reg_email: 'Please check if the e-mai is correct. Only letters of the Latin alphabet, digits, dot or spesial symbols @_- can be used',
    ua_letters_space_hyphen: 'Only letters of the Ukrainian alphabet, spaces and dashes can be used',
    neres_letters_space_hyphen: 'Only letters of the Latin alphabet, spaces and dashes can be used',
    ua_birth_place: 'Only letters of the Ukrainian alphabet, spaces, dots, commas and dashes can be used',
    neres_birth_place: 'Only letters of the Latin alphabet, spaces dots, commas and dashes can be used',
    ua_letters_space: 'Only letters of the Ukrainian alphabet and spaces can be used',
    bank_name: 'Please check, if the issuer name is correct',
    identify_code: 'Check the entered tax ID number',
    ua_letters_space_numeric: 'You can use only numbers, lowercase and uppercase letters of the Ukrainian alphabet, as well as spaces and dots',
    ua_letters_space_numeric_dash: 'You can use only numbers, lowercase and uppercase letters of the Ukrainian alphabet, as well as spaces, dots, dashes and hyphens',
    neres_letters_space_numeric: 'You can use only numbers, lowercase and uppercase letters of the Latin alphabet, as well as spaces and dots',
    neres_letters_space_numeric_dash: 'You can use only numbers, lowercase and uppercase letters of the Latin alphabet, as well as spaces and dots, dashes and hyphens',
    street_name: 'You can only use the letters of the Ukrainian alphabet and special characters .,/ or -',
    neres_street_name: 'You can only use the letters of the Latin alphabet and special characters .,/ or -',
    ua_house: 'You can only use the letters of the Ukrainian alphabet and special characters / or -/',
    neres_house: 'You can only use the letters of the Latin alphabet and special characters / or -/',
    ua_flat_number: 'You can only use the letters of the Ukrainian alphabet, numbers and special characters ./ or -',
    neres_flat_number: 'You can only use the letters of the Latin alphabet, numbers and special characters ./ or -',
    iban: 'Please check, if IBAN number is correct',
    ua_passport_series: 'Passport series should contain Latin or Ukrainian letters',
    ua_passport_series_latin: 'The passport series must contain Latin letters',
    ua_passport_series_latin_number: 'The passport series must contain Latin letters or numbers',
    eddr_number: 'Check that the entered entry number in the Unified State Demographic Register is correct',
    ua_card_expire: 'Please check, if the expiry date is correct',
    ua_valid_until: 'Check if expiry date of the document is correct',
    register_source: 'You can only use letters of the Latin and Ukrainian alphabets, numbers, spaces, commas, dots and dashes',
    neres_letters_space_dash: 'Only letters of the Latin alphabet, spaces and dashes can be used',
    neres_identify_code: 'Check the entered tax ID number. Only digits, letters of the Latin alphabet, spaces, dot and dashes can be used',
    ua_state_region: 'You can only use the letters of the Ukrainian alphabet and special characters / or -',
    neres_state_region: 'You can only use the letters of the Latin alphabet and special characters / or -',
    ua_registration_address: 'You can only use the letters of the Ukranian alphabet and special characters .,/ or -',
    neres_registration_address: 'You can only use the letters of the Latin alphabet and special characters .,/ or -',
    neres_iban: 'Please check, if IBAN number is correct',
    full_age: 'You can register only if you are over 18 years old',
    card_is_not_unique: 'Card number must be unique',
    iban_is_not_unique: 'IBAN account number must be unique',
    neres_index: 'Only letters of the Latin alphabet, spaces and dashes can be used',
    ua_address: 'You can only use the letters of the Ukrainian alphabet and special characters .,/ or -s',
    'date-range-is-not-correct': 'The starting date of the period should not exceed the ending date',
    'not_past_date': 'The report generation date cannot be later than yesterday'
  },
  'backend-errors': {
    'account-is-payout': 'This account cannot be deleted as it is designated as the primary account for foreign currency payments. Deletion will be possible after it is replaced as the primary account for foreign currency payments.'
  },
  common: {
    'year': 'Year',
    'yes': 'Yes',
    'no': 'No',
    'email': 'E-mail',
    'password': 'Password',
    'wrong-code': 'Wrong code',
    'code-not-found': 'Your code has expired. Please regenerate a new code',
    'code-expired': 'Your code has expired. Please regenerate a new code',
    'waiting-documents-from-server': 'Documents are being processed for signing',
    'time-of-waiting-documents-from-server': 'When the processing is complete (in a 15 minutes), signed documents will appear in this cabinet.',
    'if-you-have-problems': 'If you have any difficulties or questions, please contact support via e-mail:',
    'waiting-for-diia-documents': 'Documents are being generated for signing',
    'time-of-waiting-diia-documents-from-server': 'Documents will be generated within 1-2 minutes, after which you will be automatically redirected for their signing',
    'if-you-have-problems-with-phone': 'If you have any difficulties or questions, please contact support via phone or e-mail:',
    'if-you-have-questions': 'If you have any questions or difficulties with online registration, contact us via e-mail',
    'add-photo-scan-copy': 'Add photo/scan copy',
    'drag-document-or-attach': 'Drag the document or attach it using the Upload button',
    'drag-document-file-extensions': 'Please upload images in one of the following formats: jpg, jpeg, png, bmp',
    'please-make-sure-photo': 'Please make sure the document on the photo/scan copy is fully visible, has no glares or other elements that obscure the text on the document',
    'uploaded-percent': '{number}% uploaded',
    'upload-failed': 'Upload failed',
    'upload-successful': 'Upload successful',
    'unacceptable-file-format': 'Unacceptable file format. Please upload images in one of the following formats: pdf, jpg, jpeg, png, etc',
    'unacceptable-file-format-nonresident': 'Unacceptable file format. Please upload images in one of the following formats: jpg, jpeg, png, etc',
    'file-too-large': 'Unacceptable file size',
    'logout-confirm-text': 'Are you sure you want to log out of your personal cabinet?',
    'logout-confirm': 'Log out',
    'logout-decline': 'Stay',
    'wrong-login-or-password': 'The username or password you entered is incorrect, please check it'
  },
  notifications: {
    'something-went-wrong': 'Something went wrong',
    'something-went-wrong-recheck': 'Something went wrong. Check that the link is correct',
    'something-went-wrong-recheck-phone': 'Please check if the contact phone number is correct',
    'next-try-will-be-available': 'Next try will be available in {minutes}:{seconds}',
    'application-is-not-sent': 'Unfortunately, the questionnaire was not successfully submitted for verification. Please try again',
    'register-email-forbidden': 'Registration from {email} domain is not available',
    'delete-photo-message': 'Are you sure you want to delete this image?',
    'delete-photo-yes': 'Yes',
    'delete-photo-no': 'No',
    'not-found': 'Not found',
    'reset-password-wrong-token-text': 'You have already used this password recovery link before.',
    'get-link-to-update-password-button-text':'Request the password recovery link again',
    'return-to-login-button-text': 'I remember my password and want to log in',
    'citizen-modal-title':'Unfortunately, currently there is no<br/>technical possibility for stateless persons to register online.',
    'citizen-modal-text': 'You can submit a request to register using the following contacts:',
    'residency-modal-title':'Unfortunately, currently there is no<br/>technical possibility for some countries residents to register online.',
    'residency-modal-text': 'You can submit a request to register using the following contacts:',
    'non-resident-modal': 'Dear customer,<br/>Remote online registration for non-residents is currently unavailable',
    'non-resident-text': 'Please send us your request using the contacts below, and we will be sure to notify you as soon as registration starts:',
    'sms-code-send-fail-text': 'If you have not received the SMS code, please contact support e-mail:',
    'sms-code-send-fail-text-with-phone': 'If you have not received the SMS code, please contact support via e-mail:',
    'code-send-fail-text': 'If you have not received the code, please contact support e-mail:',
    'code-send-fail-text-with-phone': 'If you have not received the code, please contact support via e-mail:'
  },
  'password-hints': {
    'characters-count': '8-20 characters',
    'arabic-numbers': 'Arabic numbers 0-9',
    'latin-alphabet': 'Latin alphabet A-Z',
    'special-characters': 'Special characters @%!?'
  },
  'verification-modal': {
    'phone-need-verification-title': 'Your phone number <br>{phone} <br/>is not verified',
    'go-to-verification': 'Proceed to phone number verification',
    'phone-verification-text': 'If you wish to change your phone number, please send a request from your verified email address to support via e-mail:',
    'otp-was-sent': 'An OTP code has been sent.<br/>Please enter it to confirm the transaction',
    'resend-code': 'Resend code',
    'confirm': 'Confirm',
    'code-was-sent-to-phone': 'A code has been sent to  {phone}',
    'code-was-sent-to-email': 'A confirmation code was sent to {email}',
    'code-was-sent-to': 'A code has been sent to {contact}<br/>Please enter it to confirm the transaction',
    'sign-documents': 'Sign the documents',
    'time-left':'Code will expire in ',
    'time-left-short': 'Validity period of the code:',
    'tries-left':'Remaining attempts: ',
    'tries-left-short':'Number of attempts left:'
  },
  'login-page': {
    'get-change-password-link': 'Check out the link to change your password',
    'link-was-sent': 'An e-mail was sent to {email} with a link to change your password.',
    'forgot-password': 'Forgot the password?',
    'log-in': 'Log in',
    'email-hint': 'The email address specified during registration in ICU Trade or when making a purchase in the Diia app.',
    'password-hint': 'The password is the same as the one you created when filling out the registration form.<br/><br/>If the password is incorrect or if the first purchase of government bonds was made through the Diia app, use the ‘Forgot the password?’ button to create a new one. The password for the trading system and the personal cabinet may be different.',
  },
  'change-password': {
    'enter-your-email': 'Enter your e-mail to receive protected login link',
    'change-password': 'Change password',
    'successful-change': 'Your password was successfully changed.',
    'go-back-to-cabinet': 'Go back to your registration cabinet',
    'enter-and-confirm-password': 'Please enter and re-enter a new password',
    'enter-new-password': 'Enter new password',
    're-enter-password': 'Re-enter password'
  },
  'register': {
    'title': 'ICU Registration',
    'resident-title': 'Registration for residents of Ukraine',
    'contact-phone': 'Contact phone number',
    'email': 'E-mail',
    'password-creation-hint': 'Creating a password for your personal account will protect your personal information',
    'enter-password': 'Enter password',
    're-enter-password': 'Re-enter password',
    'register': 'Register',
    'registration': 'Registration',
    'how-did-you-find-out': 'How did you find out about us?',
    'your-option': 'Your option',
    'social-networks-option': 'Social networks (Facebook, Twitter, LinkedIn, Telegram)',
    'social-media-option': 'Social media',
    'from-friend-option': 'From friends/colleagues/family',
    'your-option-option': 'Your option',
    'phone-hint': 'Enter the phone number you are planning to use to login',
    'email-hint': 'Enter the email you plan to use to log into the system in the future',
    'already-requested': 'Your request has already been received. The manager will contact you.',
    'diya-registration-btn-text': 'Verify via Diia app',
    'diya-registration-btn-hint': 'Via Diia.Sharing - automatic filling in of the application form and quick transfer of documents',
    'bankid-registration-btn-text': 'Verify via BankID NBU',
    'bankid-registration-btn-hint': 'Via BankID NBU - manual filling in of the application form and uploading of documents',
  },
  'qr-code': {
    'scan-qr': 'Scan this QR-code using the Diia app',
    'scan-qr-subtext': 'Follow the instructions in the Diia app to successfully complete the registration process',
    'scan-qr-diia-subtext': 'Follow the instructions in the Diia app to successfully sign the documents using Diia.Digital Signature',
    'scan-qr-block-text': 'Continue in 00:{sec}',
    'proceed': 'Continue',
    'scan-qr-error': 'Scan the QR-code to continue',
    'scan-qr-mobile-error': 'Please click on the QR code to go to the Diia mobile app',
    'qr-expired': 'Your QR-code has expired. Please regenerate a new code',
    'qr-proceed-to-finish': 'Please complete the process in the Diia app',
    'try-again': 'Try again',
    'get-new-qr': 'Generate a new QR-code',
    'qr-error': 'Something went wrong. Please retry ',
    'update-qr':'Generate a new QR-code',
    'back-to-site': 'Return to the website',
    'account-opening-process': 'The opening of your account is in progress. This may take some time. Expect further notifications via e-mail. Thank you for your understanding!',
    'process-success': 'The registration process is complete. You have already been granted access to the trading system. Access link has been sent to your email address.',
    'go-to-cabinet': 'Access the trading cabinet',
    'no-full-data-text': 'Unfortunately, the documents provided by Diia are not sufficient for registration',
    'no-full-data-hint': 'Please check if ID-document and tax ID number (TIN) are available in your Diia app and try again. If the error reoccurs, use manual data entry via BankID NBU',
    'try-diya': 'Try again via Diia.Sharing',
    'register-bank-id': 'Register manually via BankID NBU',
    'error-text': 'Unfortunately, an error has occurred during the automatic data transfer',
    'error-hint': 'Please try again or use the manual data entry using the BankID NBU',
    'not-unique-data': 'The data you entered is connected with the other user in our system. To register, please enter unique data. If you have not previously registered, click on the "Contact the Manager" button and we will get in touch shortly.',
    'call-manager': 'Contact the manager',
    'waiting': 'Waiting for the server response',
    'contacts': 'If you have any difficulties or questions, please contact support via e-mail:',
    'cancel-registration': 'Cancel registration',
    'continue-registration': 'Continue registration',
    'continue-diia-sign': 'Continue signing',
    'cancel-diia-sign': 'Cancel',
    'cancel-registration-request': 'Are you sure you want to cancel registration via Diia?',
    'cancel-diia-sign-request': 'Cancel the signing of documents with Diia.Digital Signature?',
    'scan-qr-mobile-subtext1': 'Click on the QR code to go to the Diia mobile app.',
    'scan-qr-mobile-subtext2': 'Follow the instructions in the Diia app to successfully complete the registration process.',
    'scan-qr-mobile-diia-sign-subtext2': 'Follow the instructions in the Diia app to successfully sign the documents using Diia.Digital Signature.',
    'scan-qr-mobile-success1': 'Your documents were successfully transferred!',
    'scan-qr-doc-sign-success': 'Document signing has been successfully completed!<br/><br/>You now have access to the client\'s personal account. The login and password are the same as those you provided at the start of registration. Shortly after processing the documents, you will also be granted access to the ICU Trade system. A link to create a password for ICU Trade will be sent to your email address.',
    'scan-qr-mobile-doc-sign-success1': 'Document signing has been successfully completed!',
    'scan-qr-mobile-success2': 'Please return to the tab or device where you started the registration and click the "Continue" button there',
    'scan-qr-mobile-doc-sign-success2': 'Please return to the webpage from which you proceeded to sign (using Diia.Signature) and click the ""Continue"" button',
    'scan-qr-doc-sign-success-to-cabinet': 'Proceed to the client\'s personal account',
    'choose-register-source': 'Choose your remote verification option',
    'confirm-data': 'I confirm the info / Send the questionnaire'

  },
  'duplicate-check': {
    'phone-or-email-is-used': 'The specified phone number or email address is already in use. To register, change your data. If you have not registered previously, click on the "Contact Manager" button and our manager will contact you shortly.',
    'contact-the-manager': 'Contact the manager',
    'manager-has-been-notified': 'Our manager has been notified and will contact you shortly',
  },
  'register-final-page': {
    'thanks-for-application': 'Thank you for your application!',
    'application-was-sent': 'Your questionnaire has been submitted to the ICU for review <br><br> Expect a notification to your e-mail address shortly with further instructions on signing the Agreement.',
    'back-to-site': 'Back to site',
    'to-cabinet': 'Proceed to your personal cabinet'
  },
  'application-form': {
    'modal': {
      'header':'Requirements for filling in the questionnaire for {resident_status} of Ukraine',
      'text':'The fields of the online questionnaire must be filled in {lang}.',
      'button':'Confirm',
      'resident': 'residents',
      'nonresident': 'non-residents',
      'lang': {
        'ua': 'Ukrainian',
        'en': 'English'
      }
    },
    'continue': 'Continue',
    'i-confirm': 'Sign and confirm you have filled the questionnaire personally',
    'add-another-account': 'Add another account',
    'press-to-send': 'Click to send the questionnaire for verification',
    'citizenship-step': {
      'placeholder': 'Ukraine'
    },
    'step-0':{
      'title': 'ICU client registration',
      'register': 'Register',
      'employees': 'Choose the employment type',
      'proceeds': 'Choose your monthly income level',
      'no-citizenship': 'Statelessness',
      'citizenship': 'Enter the country of you citizenship',
      'residency': 'What is your residence country?'
    },
    'step-1': {
      'title': 'Step 1 of 5: Full name, contact info, birthplace and tax ID number',
      'phone': 'Contact phone number',
      'email': 'E-mail',
      'last-name': 'Last name',
      'last-name-nonresident': 'Еnter your last name in Latin according to the identification document',
      'last-name-hint-uk': 'Enter your last name in Ukrainian',
      'last-name-hint-en': 'Enter your last name in Latin',
      'first-name': 'First name',
      'first-name-nonresident': 'Еnter your first name in Latin according to the identification document',
      'first-name-hint-uk': 'Enter your first name in Ukrainian',
      'first-name-hint-en': 'Enter your first name in Latin',
      'middle-name': 'Middle name',
      'middle-name-nonresident': 'Еnter your middle name in Latin according to the identification document',
      'middle-name-hint-uk': 'Enter your middle name in Ukrainian',
      'middle-name-hint-en': 'Enter your middle name in Latin',
      'date-of-birth': 'Date of birth',
      'date-of-birth-hint': 'Enter your full date of birth',
      'country-of-birth': 'Country of birth',
      'country-of-birth-hint': 'Enter your country of birth',
      'place-of-birth': 'Place of birth',
      'place-of-birth-hint': 'Enter your place of birth',
      'citizenship': 'Citizenship',
      'citizenship-hint': 'Enter the country of you citizenship',
      'residency': 'Residence',
      'tax-residency': 'Tax residency',
      'has-inn': 'I have a Ukranian TIN',
      'tax-id-number': 'Tax ID number of Ukraine',
      'tax-id-number-short': 'Tax ID number',
      'your-country-has-inn': 'I have my country TIN',
      'your-country-tax-id-number': 'Tax ID number of you country',
      'foreign-has-inn': 'I have foreign country TIN',
      'foreign-tax-id-number': 'Tax ID number of foreign country',
      'tax-id-number-hint': 'Enter you tax ID number (if available)',
      'photo-scan-tax-id': 'Upload a copy of the original TIN<br>(a screenshot from the Diia application is not accepted)',
      'photo-scan-without-ipn': 'Add photo / scan of the passport page with the note about TIN absence and photo / scan of TIN absence certificate',
      'photo-tax-id-number': 'Photo/scan copy of the tax ID number'
    },

    'step-2': {
      'title': 'Step 2 of 5: Identification info',
      'id-document-subtitle': 'ID-document',
      'document-type': 'Document type',
      'document-type-hint': 'Choose document type',
      'country':'Country',
      'my-passport-is-biometric': 'My passport is biometric',
      'reestr-number-id-card': 'Unique record number in the Unified State Demographic Register',
      'reestr-number': 'Unique record number in the Unified State Demographic Register',
      'reestr-number-hint': 'Enter the entry number in the Unified State Demographic Register from your foreign passport - field "Record No"',
      'series': 'Series',
      'series-hint': 'Enter passport series in Latin or Ukrainian letters',
      'series-international-hint': 'Enter the series of the passport in Latin letters',
      'series-international-number-hint': 'Enter the series of the passport in Latin letters or numbers',
      'passport-id-number': 'Passport ID number',
      'id-number': 'ID number',
      'id-card-number': 'ІD-card number',
      'passport-id-number-hint': 'Enter document number',
      'date-of-issue': 'Date of issue',
      'date-of-issue-hint': 'Enter the date of issue of your passport',
      'date-of-expiry': 'Date of expiry',
      'date-of-expiry-hint': 'Enter expiry date of the document',
      'issuing-authority-text-hint': 'Enter the name of the authority that issued the identity document as indicated on the document',
      'issuing-authority-code-hint': 'Enter the name of the authority that issued the identity document as indicated on the document',
      'issuing-authority': 'Issuing authority',
      'issuing-authority-code': 'Code of the authorized entity that issued the document',
      'photo-passport-label':'Photo/scan of all passport pages with marks (photos/scans of pages 0-1, 2-3, 4-5, 6-7, 10-11, 12-13 must be attached)',
      'photo-passport-label-non-citizen':'Photo/scan copy of all passport pages',
      'photo-passport-hint':'Photo/scan of all passport pages with marks (photos/scans of pages 0-1, 2-3, 4-5, 6-7, 10-11, 12-13 must be attached). Drag the document into the box or attach it using the Upload button.',
      'photo-foreign-passport-hint':'Attach a photo or scan of the document. Drag the document into the box or attach it using the Upload button',
      'photo-id-label': 'Photo / scan copy of the two sides of the ID-card',
      'photo-id-hint': 'Add a scan or photo of both sides of the card.',
      'photo-foreign-id-hint': 'Attach a photo or scan of the document.',
      'photo-int-passport-label': 'First page of the foreign passport',
      'photo-int-passport-hint': 'Attach a photo or scan of the first page of the foreign passport.',
      'photo-doc-label': 'Photo/scan copy of all document pages',
      'photo-doc-short': 'Photo/scan copy of ID-document',
      'photo-doc-hint': 'Attach a photo or scan of the document. Drag the document into the box or attach it using the Upload button',
      'photo-doc-nonresident': 'Upload a photo/scan of an ID-document with an English translation or an international passport',
      'certificate-of-residence': 'An extract about the place of residence (photo of the original or a file from the Diia app)',
      'certificate-of-residence-hint': 'Upload a «An extract about the place of residence (photo of the original or a file from the Diia app)».<br><br> Drag the document into the box or attach it using the Upload button.',
      'second-photo': 'The second passport photo',
      'second-photo-hint': 'You are over 45 years old. Attach an additional scan with the second photo in the passport',
      'photo-selfie-label': 'Selfie with an identity document',
      'photo-selfie-label-nonresident': 'Upload a selfie with the ID-document from the previous step. The photo should clearly show your face and the text on the document',
      'photo-selfie-hint': 'Take a selfie with your ID document. The document must be fully and clearly visible in the frame. Drag the file into the field or attach it using the upload button',
    },

    'step-3': {
      'title': 'Step 3 of 5: Address of registration and current residence',
      'address-subtitle': 'Address of registration',
      'registration-address': 'Address of registration',
      'address-placeholder': '01054, Україна, м. Київ, вул. Богдана Хмельницького 19-21',
      'address-hint': 'Enter the full address as in the following example: 19-21 Bohdana Khmelnytskoho St., Kyiv, 01054, Ukraine',
      'living-address': 'Address of actual residence',
      'country': 'Country',
      'country-hint': 'Enter your country',
      'region': 'Region',
      'region-hint-en': 'Enter region name in Latin',
      'region-hint-uk': 'Enter region name in Ukrainian',
      'settlement-type': 'Type of settlement',
      'settlement-type-hint': 'Choose a type of settlement',
      'settlement': 'City/town/village',
      'settlement-hint-uk': 'Enter the name of the settlement in Ukrainian',
      'settlement-hint-en': 'Enter the name of the settlement in Latin',
      'street-type': 'Type of street',
      'street-type-hint': 'Choose the type of the street',
      'street': 'Street',
      'street-hint-en': 'Enter street name in Latin',
      'street-hint-uk': 'Enter street name in Ukrainian',
      'house': 'Building Number',
      'house-hint': 'Enter your street building number',
      'flat': 'Apartment',
      'flat-hint': 'Enter your apartment number',
      'index': 'Index',
      'index-hint': 'Enter ZIP-code or Post Code',
      'registration-is-living-subtitle': 'Current address',
      'registration-is-living': 'Current address matches the address of registration',
      'is-internal-migrant': 'I am an internally displaced person from the territory of Crimea or occupied territories of Donetsk/Lugansk regions',
      'migrant-certificate': 'Certificate of internally displaced person',
      'migrant-certificate-hint': 'Please attach the certificate of IDP (internally displaced person), if you were displaced from the territory of Crimea or occupied territories of Donetsk/Lugansk regions',
      'state-or-region': 'State / region',
      'state-or-region-hint-en': 'Enter region name in Latin',
      'state-or-region-hint-uk': 'Enter region name in Ukrainian',
      'actual-address': 'Residential address',
      'actual-address-hint': 'Enter the address of registration: city, street name, house and apartment number',
      'photo-scan-certificate': 'Photo / scan of the certificate of registration of residence'
    },

    'step-4': {
      'title': 'Step 4 of 6: Bank account and card details for client withdrawals',
      'data-warning': 'Please carefully check the accuracy of the fields. If the data is entered incorrectly, it will be impossible to withdraw funds to the specified details!',
      'another-account': 'Another account',
      'iban': 'IBAN / Client account number',
      'iban-hint': 'Numbers and Latin letters only',
      'swift': 'SWIFT / BIC code',
      'number': 'Account number',
      'name': 'Account name',
      'additional_information': 'Additional bank details and intermediary bank details (name, SWIFT, BIC) — can be entered in one line',
      'bank': 'Users bank name ',
      'bank-hint': 'Enter the name of the issuer bank in Ukrainian or Latin',
      'card_number': 'Bank card number linked of the IBAN number',
      'card_number-hint': 'Enter the number of the bank card linked to the IBAN number',
      'card_expire': 'Expiry date',
      'card_expire-hint': 'Enter the expiry date of your card',
      'currency': 'Account currency',
      'currency-nonresident': 'Currency',
      'currency-hint': 'Choose the bank account currency',
      'doc': 'The attachment (photo, screenshot, scanned copy of the bank certificate) must confirm that the specified IBAN/account number belongs to you and contain all additional details of the intermediary banks (name, SWIFT, BIC), if available',
      'doc-hint': 'Photo/scan copy of your account\'s bank reference or screenshot of account details with IBAN/Client account number from your banking app',
      'add-card-1': 'Add{more} bank card to this',
      'add-card-2': 'IBAN account'
    },

    'step-5': {
      'title': 'Step 4 of 5: Information for FATCA purposes',
      'is_usa_citizen': 'Are you a citizen of the United States?',
      'has_residence': 'Do you have a US permanent residence permit (green card, etc.)?',
      'is_usa_born': 'Have you been born in USA?',
      'has_usa_address': 'Do you have a US residence or correspondence address? Hold mail or in-care-of address?',
      'has_usa_phone': 'Do you have US telephone number?',
      'has_usa_payment_order': 'Do you have a standing payment order for funds transfer to the US accounts (with the investment or savings purposes)?',
      'has_usa_p_a': 'Have you given Power of Attorney or Signature Authority to a person with US address?',
      'tin_code': 'Please enter your US TIN',
      'tin_code-hint': 'Enter TIN',
    },

    'step-6': {
      'title': 'Step 5 of 5: Purpose and nature of business relationship with ICU',
      'target': 'Purpose of business relationship',
      'target-hint': 'Choose one of the available options',
      'frequency': 'Nature of business relationship',
      'frequency-hint': 'Choose one of the available options',
      'date': 'Date of registration',
    },
  },
  'form-status': {
    'clarify-title': 'It is necessary to clarify the data',
    'clarify-text':'For the fastest data clarification, please contact us via e-mail at',
    'clarify-text2': 'or await our contact',
    'denied-title':'Unfortunately, your application registration has been rejected',
    'denied-text':'You can obtain information about the reason for the rejection via e-mail:',
    'denied-button-text': 'Return to the site',
    'ready-title':'Your documents are ready for signing',
    'ready-text':'The next step is to sign the documents. You will be provided with access data to the client\'s personal account, and after the documents are processed at ICU, you will also receive access data to the ICU Trade system. Please note that this may take some time.',
    'ready-button-text':'Proceed to signing documents'
  },
  'document-sign': {
    'title':'Signing the documents',
    'text': 'By clicking the "Sign Documents" button, you confirm their authenticity and consent to the use of your personal data for opening an account at ICU',
    'button-text':'Sign documents',
    'download': 'Download',
    'if-find-errors': 'If you identify any mistakes in the documents, please contact our support team via email at',
    'contact-support': 'If you have any questions or problems, please contact us via e-mail: ',
    'sign-by-diia': '<span class="d-s">Sign documents using the <span>Diia.Signature</span></span>',
    'success': {
      'title': 'Thank you! Documents have been successfully signed',
      'text': 'Soon you will receive a link to your email to register in the ICU Trade system, where you can buy government bonds and support the victory of Ukraine.',
      'button': 'Proceed to your personal cabinet'
    },
    'error': {
      'title': 'Something went wrong, the documents were not signed ((',
      'text': 'Try to go back one step and sign the documents again',
      'button': 'Go back'
    }
  },
  'signed-documents': {
    'page-title': 'Signed documents',
    'contact-support': 'If you have found any errors in the documents or your personal data has changed, be sure to contact us via e-mail to update the information:',
    'contact-support-with-phone': 'If you have found any errors in the documents or your personal data has changed, be sure to contact us via e-mail to update the information:'
  },
  'diya-check-data': {
    'title': 'Check the data and fill in the blank fields to complete the registration',
    'contacts-title': 'Full name, contact info, birthplace and tax ID number',
    'document-title': 'Identification info',
    'address-title': 'Address of registration and current residence',
    'account-title': 'Bank account and card details for client withdrawal',
    'fatca-title': 'Information for FATCA purposes',
    'business-point-title': 'Purpose and nature of business relationship with ICU',
    'press-to-send': 'Click to send the questionnaire for verification'
  },
  'server-error': {
    'header': 'Temporary unavailable. Scheduled server maintenance.',
    'support-text':'If you have any questions, please contact us via e-mail:'
  },
  'pc': {
    'general': {
      'confirm-exit': 'Are you sure you want to sign out of your account?',
      'exit': 'Sign out',
      'stay': 'Stay',
      'active': 'Active',
      'in-process': 'In process',
      'save': 'Save',
      'cancel': 'Cancel'
    },
    'menu': {
      'my-profile': 'My profile',
      'security': 'Data and security',
      'funds': 'Bank accounts',
      'document-request': 'Requested documents',
      'documents': 'Received documents',
      'trade-limits': 'Trading limits',
      'messages': 'Notifications',
      'exit': 'Exit'
    },
    'verification': {
      'title': 'Verification method',
      'text': 'Choose how you want to receive your one-time password',
      'verification-success-title': 'Thank you for verifying your phone number',
      'verification-success-message': 'Access to your personal account has been restored',
      'return': 'Login'
    },
    'personal-data': {
      'title': 'Personal data',
      'show-all': 'Show all the data',
      'hide': 'Minimize',
      'tooltip-text': 'Changes can only be made by an ICU employee. Please send a request to the email address',
      'backoffice-status': 'Account status',
      'employment': 'Type of employment',
      'proceeds': 'Income per month',
    },
    'password': {
      'title': 'Password',
      'enter-password': 'Enter the new password',
      'confirm-password': 'Repeat the new password',
      'change-password': 'Change the password'
    },
    'messages': {
      'title': 'System notifications',
      'show-only-nonread':'Show unread only',
      'SYSTEM': 'System',
      'press-to-read': 'Press to read the notification',
      'mark-as-read': 'Mark as read'
    },
    'trade-limits': {
      'last-update': 'Last updated at',
      'note': '* The balance data does not include trading transactions from the current trading day',
      'update': 'Update the info ',
      'total-funds':'Total funds',
      'available-funds': 'Available funds',
      'blocked-funds': 'Blocked funds',
      'add-document': 'Add the income verification document',
      'doc-archive': 'Archive of income verification documents',
      'gk-confirm': 'Proof of income documents',
      'invest-limits': 'Investment limit*',
      'invest-limits-rest': 'Investment limit balance**',
      'note-1': '* Amount of verified funds available for investment',
      'note-2': '** The amount of funds that the Client can transfer to the Broker without income verification',
    },
    'accounts': {
      'title': 'FX accounts',
      'fx-accounts-text': 'There are no FX accounts available. You can choose the account from the list below by clicking the "Make default FX account" button',
      'account-delete-confirm': 'Are you sure you want to delete ',
      'current-account': 'this account',
      'current-card': 'this card',
      'account-delete': 'Yes, delete',
      'account-delete-cancel': 'No, do not delete',
      'choose-currency': 'Select the currency for which this account will be used as default for FX payments',
      'save-choose': 'Save selection',
      'accounts-tooltip-text': 'Bank accounts to be used for FX payments (dollar, euro). For additional questions:',
      'bank-cards': 'Verified bank accounts and cards',
      'cards-tooltip-text': 'Bank accounts and cards to be used for withdrawing funds. For additional question:',
      'usd': 'USD',
      'eur': 'EUR',
      'uah': 'UAH',
      'withdraw-make':'Make default FX account',
      'add-account': 'Add bank account/card',
      'change-payout': 'Are you sure you want to change {currency} account for FX payments to <span>{iban}</span>',
      'account-has-no-card': '(This IBAN does not have a card number)',
      'e-support-text': 'Important! <b>eSupport cards cannot be used as payment cards</b>, except for payments on government bonds purchased through the Diia app.',
      'confirm-replace': 'Yes, change default FX account',
      'cancel-replace': 'No, do not change',
      'additional-information': 'Additional information',
      'card-manage': 'Card management',
      'verified-cards': 'Verified bank cards',
      'card-confirm-image-label': 'The attachment must confirm that the selected client card truly belongs to you',
      'card-confirm-image-hint': 'Attachment (bank certificate/screenshot of details from your bank\'s application) must confirm that the selected bank account and/or card really belong to you',
    },
    'documents': {
      'sign': 'Sign',
      'download': 'Download',
      'download-sign': 'Download the signature',
      'APPROVED': 'Approved',
      'REJECTED': 'Rejected',
      'PROCESS': 'In process',
      'IN_PROCESS': 'In process',
      'PROCESSING': 'In process',
      'all': 'All',
      'mark_all_as_read': 'Mark as read',
      'request-archive':'Archive of requests',
      'create-request': 'Make a new request',
      'create-request-description': 'To request a document, select the type of document and then the desired time period',
      'choose-doc-type': 'Select the document type',
      'choose-date': 'Select the time period',
      'start-date': 'Start of the period',
      'end-date': 'End of the period',
      'request': 'Request',
      'all-received': 'All received documents',
      'waiting': 'Awaiting signature',
      'type-filter': 'Filter by the document type',
      'description': 'Documents sent upon your request or issued by the broker',
      'doc-name': 'Document title',
      'doc-type': 'Document type ',
      'send-date': 'Upload date',
      'request-date': 'Date of request',
      'request-period': 'For a period',
      'status': 'Status',
      'actions': 'Actions'
    },
    'document-request': {
      'title': ''
    }

  }
}
